import React from 'react';
import { useFormContext } from 'react-hook-form';

function SelectField({ id,
  required,
  defaultValue,
  values,
  label,
  searchable }) {
  const { register } = useFormContext();

  return (
    <div className="floating-label-wrapper">
      <select
        id={id}
        className={`Select w-full ${searchable ? 'Select--searchable' : ''}`}
        {...register(id, { required })}
        defaultValue={defaultValue}
      >
        <option data-placeholder="true"></option>
        {values.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <label htmlFor={id} className="floating-label">
        {label} {required ? '*' : ''}
      </label>
    </div>
  )
}

export default SelectField;
